
import axios from "@/plugins/http";
import { SMTasks, SMUser } from "@/store";
import { API_ROUTES } from "@/utils/API";
import { computed, defineComponent, onMounted, ref, watch } from "vue-demi";

export default defineComponent({
  name: "RTWCStep1",
  components: {
    ActionButtons: () => import("@/components/ActionContainer/ActionButtonsV2.vue"),
    ActionContainerCard: () => import("@/components/ActionContainer/ActionContainerCard.vue"),
  },
  emits: ["proceed"],
  setup(props, { emit }) {
    const loading = ref(false);

    const isConfirmed = ref(false);

    const isError = ref(false);

    const errorMessage = ref(
      "We’re experiencing a technical issue on our side. Please close this task and try again. If the problem persists, contact our support team for assistance."
    );

    const payload = ref({
      date_of_birth: SMUser.user?.date_of_birth || "",
      share_code: "",
      company_name: SMUser.user?.company?.CompanyProfile?.name || "",
      task_id: SMTasks.taskTemplate.id,
    });

    async function fetchCompanyName() {
      if (payload.value.company_name) return;

      if (!SMUser.isExpert) return;

      const companyId = Number(SMTasks.taskTemplate.company_id ?? 0);

      if (!companyId) return;

      try {
        const { data } = await axios.get<string>(API_ROUTES.EXPERT_COMPANIES_NAME(companyId));

        if (!data) return;

        payload.value.company_name = data;
      } catch (error) {
        console.error("Error prefilling company name", error);
      }
    }

    const isPayloadValid = computed(() => {
      return Object.values(payload.value).every(
        (val) => val !== "" && val !== null && val !== undefined
      );
    });

    const isMaskCompleted = ref(true);

    function completeMask(isCompleted: boolean) {
      isMaskCompleted.value = isCompleted;
    }

    const isDisabled = computed(
      () =>
        isError.value ||
        !isConfirmed.value ||
        loading.value ||
        !isPayloadValid.value ||
        !isMaskCompleted.value
    );

    async function runBot() {
      try {
        loading.value = true;

        const { data } = await axios.post(API_ROUTES.COMPLIANCE_RTWC, payload.value);

        if (!data) return;

        emit("proceed", data);
      } catch {
        isError.value = true;
      } finally {
        loading.value = false;
      }
    }

    watch(
      () => payload.value,
      () => {
        isError.value = false;
      },
      { deep: true, immediate: true }
    );

    onMounted(() => {
      fetchCompanyName();
    });

    return {
      loading,
      isConfirmed,
      isDisabled,
      payload,
      runBot,
      isError,
      errorMessage,
      completeMask,
    };
  },
});
